import { useEffect } from 'react';

export const useOnEsc = (
  callback: () => void,
  options?: { stopPropagation?: boolean; capturingPhase?: boolean },
) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.defaultPrevented) {
        // If the event has already been handled, do nothing
        return;
      }
      if (options?.stopPropagation ?? false) {
        e.stopPropagation();
      }
      if (e.key === 'Escape') {
        callback();
      }
    };

    document.addEventListener('keydown', handleKeyDown, options?.capturingPhase ?? false);
    return () => {
      document.removeEventListener('keydown', handleKeyDown, options?.capturingPhase ?? false);
    };
  }, [callback, options?.capturingPhase, options?.stopPropagation]);
};
